import { render } from "./AppButtonExport.vue?vue&type=template&id=06df615d&scoped=true"
import script from "./AppButtonExport.vue?vue&type=script&lang=js"
export * from "./AppButtonExport.vue?vue&type=script&lang=js"

import "./AppButtonExport.vue?vue&type=style&index=0&id=06df615d&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06df615d"]])

export default __exports__